import { navLinks } from "../../../mocks/bizlab";

export default function Footer() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-slate-900 text-slate-400">
      <div className="max-w-7xl mx-auto px-4 md:px-6 pt-16 pb-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="flex flex-col items-start mb-5">
              <img
                src="https://storage.readdy-site.link/project_files/7fd5f5de-8ad2-4f36-8769-ff3daef12068/9b8fc0c6-e244-4ff8-8c9d-1896d972ed7f_BizLab_logo_transparent.png?v=105ca1c1cf80833d97e25aee3ca9f5b1"
                alt="BizLab"
                className="h-12 md:h-24 w-auto object-contain brightness-0 invert"
              />
              <p className="mt-4 text-xs italic font-medium uppercase tracking-[0.18em] text-slate-500">
                by FOURLAB
              </p>
            </div>

            <p className="text-sm leading-relaxed text-slate-500 max-w-[260px]">
              Modern workplace management platform for enterprise teams.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xs font-bold uppercase tracking-widest text-white mb-5">
              Quick Links
            </h4>
            <ul className="space-y-3">
              {navLinks.map((link) => (
                <li key={link.label}>
                  <button
                    onClick={() => handleNavClick(link.href)}
                    className="text-sm text-slate-500 hover:text-white transition-colors duration-200 cursor-pointer"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="lg:col-span-2">
            <h4 className="text-xs font-bold uppercase tracking-widest text-white mb-5">
              <a href="#contact" className="hover:text-blue-400 transition-colors">
                Contact
              </a>
            </h4>

            <ul className="space-y-3 text-sm text-slate-500">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-slate-400 shrink-0" />
                <a
                  href="mailto:4lab@4-lab.com"
                  className="hover:text-white transition-colors"
                >
                  4lab@4-lab.com
                </a>
              </li>

              <li className="flex items-start gap-2">
                <i className="ri-phone-line mt-0.5 text-slate-400 shrink-0" />
                <span>+82 (02) 881-5738</span>
              </li>

              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-0.5 text-slate-400 shrink-0" />
                <span>
                  6F, Room 19, 540 Misadaero,
                  <br />
                  Hanam-si, Gyeonggi-do
                  <br />
                  (Hyundai Knowledge Industry Center Hangang Misa 2nd)
                </span>
              </li>

              <li className="flex items-start gap-2 mt-2">
                <i className="ri-time-line mt-0.5 text-slate-400 shrink-0" />
                <span>Mon–Fri, 9 AM – 6 PM (KST)</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-slate-800 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-600">
            &copy; {new Date().getFullYear()} FOURLAB Inc. All rights reserved.
          </p>

          <p className="text-xs text-slate-600">
            BizLab is a product of FOURLAB.
          </p>
        </div>
      </div>
    </footer>
  );
}